// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MessageList_wrapper__CWBAo","spin":"MessageList_spin__zCIgf","info":"MessageList_info__ez_Fi"};